import { VideoPlayer } from 'bootstrap-italia/dist/bootstrap-italia.esm.js';

function loadYouTubeVideo(button) {
  const targetId = button.dataset.videoTargetId || '';
  const youtubeUrl = button.dataset.youtubeUrl || '';

  if (!targetId || !youtubeUrl) {
    return;
  }

  const videoEl = document.getElementById(targetId);
  if (!videoEl) {
    return;
  }

  const player = VideoPlayer.getOrCreateInstance(videoEl);
  player.setYouTubeVideo(youtubeUrl);
}

function setupVideoButtons() {
  document.querySelectorAll('.js-mir-load-youtube-video').forEach((button) => {
    button.addEventListener('click', () => {
      loadYouTubeVideo(button);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupVideoButtons);
} else {
  setupVideoButtons();
}
